var React = require('react');

function FacebookBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"style":{"fill":"#000000"},"d":"M10 0.4c-5.302 0-9.6 4.298-9.6 9.6s4.298 9.6 9.6 9.6 9.6-4.298 9.6-9.6-4.298-9.6-9.6-9.6zM12.274 \n \t7.034h-1.443c-0.171 0-0.361 0.225-0.361 0.524v1.042h1.805l-0.273 1.486h-1.532v4.461h-1.703v-4.461h-1.545v-1.486h1.545v-0.874c0-1.254 \n\t 0.87-2.273 2.064-2.273h1.443v1.581z"}));
}

FacebookBlack.defaultProps = {"version":"1.1","id":"svgfacebookblack","x":"0px","y":"0px","viewBox":"0 0 20 20","style":{"enableBackground":"new0 0 20 20"},"xmlSpace":"preserve"};

module.exports = FacebookBlack;

FacebookBlack.default = FacebookBlack;
